export default __webpack_public_path__ + "static/media/6.b8bbc6d0.png";